import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'react-inlinesvg';
import { Responsive } from 'semantic-ui-react';
import { Breakpoints } from '../../../utils';
import { download2Icon } from '../../../images';

// `FileName` expected
const DownloadCell = ({ cell, ...rest }) => {
  const { FileName } = rest.row.original;
  return (
    <a
      href={cell.value}
      download
      aria-label="link download to asset"
      data-test={`${FileName}-download`}
    >
      <Responsive
        as={Svg}
        maxWidth={Breakpoints.computerBreakpoint - 1}
        src={download2Icon}
        accessibilityLabel="Download Icon"
        accessibilityDesc="Download for downloading the appropriate asset"
      />

      <Responsive
        as="small"
        minWidth={Breakpoints.computerBreakpoint}
        className="link--boxed table__item--hidden"
      >
        DOWNLOAD
      </Responsive>
    </a>
  );
};

DownloadCell.propTypes = {
  isCell: PropTypes.bool,
  cell: PropTypes.object
};
export default DownloadCell;



// WEBPACK FOOTER //
// ./src/components/AssetDownloadsTable/cells/DownloadCell.js